import React from 'react';
import { MenuItem } from '@mui/material';
import { t } from 'i18next';
import { CustomTextField } from '../../../../components/CustomTextField';
import { CustomSelectAndChildren } from '../../../../components/CustomSelectAndChildren';
import {MIN_MAX_CONTROLLER} from "./Model/Models";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const FieldsController = ({ controller, handleChange, emptyFields, allStatus, isValidIp, isValidOffset, disabled }) => {

    return (
        <>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={"txt_fc_name"}
                    disabled={disabled}
                    trans={"name"}
                    name={"name"}
                    type={"text"}
                    value={controller.name}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    length={128}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={"txt_fc_ip_address"}
                    disabled={disabled}
                    trans={"ip"}
                    name={"ipAddress"}
                    type={"text"}
                    value={controller.ipAddress}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    length={128}
                    isValid={isValidIp}
                    isValidText={"invalid_ip_format"}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomSelectAndChildren
                    id={"slt_fc_status_id"}
                    disabled={disabled}
                    name={"statusId"}
                    trans={"status"}
                    value={controller.statusId || ''}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    showNoSelectionOption={false}
                >
                    {Array.isArray(allStatus) &&
                        allStatus.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {t(item.name)}
                            </MenuItem>
                        ))}
                </CustomSelectAndChildren>
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField id={"txt_fc_scp_id"}
                                trans={"SCP_ID"}
                                name={"scpId"}
                                type={"number"}
                                value={controller.scpId}
                                onChange={handleChange}
                                required={true}
                                emptyFields={emptyFields}
                                length={128}
                                disabled={disabled || controller.id}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                     id={"txt_fc_offset"}
                     disabled={disabled}
                     trans={"random_seed"}
                     name={"offset"}
                     type={"number"}
                     value={controller.offset}
                     onChange={handleChange}
                     required={true}
                     emptyFields={emptyFields}
                     isValid={isValidOffset}
                     isValidText={t('it_must_be_greater_than_or_equal_to', {min:MIN_MAX_CONTROLLER.OFFSET.start})}
                     helperText={t('it_must_be_greater_than_or_equal_to', {min:MIN_MAX_CONTROLLER.OFFSET.start})}
                />
            </div>
            <div className='col-sm-12 col-xxl-6 col-lg-6'>
                <CustomTextField
                    id={"txt_fc_channel_id"}
                    trans={"CHANNEL_ID"}
                    name={"channelId"}
                    type={"number"}
                    value={controller.channelId}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    length={128}
                    disabled={disabled || controller.id}
                />
            </div>
            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomTextField id={"txt_fc_description"}
                    trans={"description"}
                    name={"description"}
                    type={"text"}
                    value={controller.description}
                    onChange={handleChange}
                    multiline={true}
                    length={512}
                    disabled={disabled}
                />
            </div>
        </>
    );
};

export default FieldsController;
